<script>
  import { Popover } from 'bootstrap';
  import DropDown from '../DropDown.svelte';
  import EditTaskModal from '../EditSubTaskModal.svelte';
  import DatePicker from '../Flatpickr/DatePicker.svelte';
  import AddTaskModal from '../AddTaskModal.svelte';
  import AddTaskTempleteModal from '../AddTaskTemplateModal.svelte';
  import { Modal } from 'bootstrap';
  let assignTaskTable = false;
  import { client } from 'root/api/index.js';
  import { searchKeyByValue, cloneArray } from 'components/Helper.js';
  let changeFrequency;
  let changeResponsibleParty;

  export let projectTypes = [];
  export let clientTypes = [];
  export let registrationTypes = [];

  import { getUserInfo } from '../../stores/auth';
  import moment from 'moment';
  const userDateFormat = (date) => {
    return moment(date).format(getUserInfo().datePickerMomentJsFormat);
  };

  const editTaskTemplate = (taskTemplateId) => {
    var allValues = datatableRef.getValues();
    let key = searchKeyByValue(allValues, 'id', taskTemplateId);
    let params = {};
    if (key != -1 && allValues[key].subTaskTemplates != undefined) {
      params.subTaskTemplates = allValues[key].subTaskTemplates;
    }
    taskTempleteModal.show(taskTemplateId, 'assignTask', params);
  };
  let taskTempleteModal;

  export let extraFilter;
  let recurringRow;
  let firstTimeGridLoad = true;
  $: extraFilter && filterData();

  export const checkSelectedTask = () => {
    return tasks.length > 0 || taskTemplates.length > 0;
  };

  const initPopupOver = () => {
    var tooltipElements = document.querySelectorAll('.popover.show');
    tooltipElements.forEach(function (el) {
      el.remove();
    });
    var elements = document.querySelectorAll('.add_task_popup');
    elements.forEach(function (el) {
      new Popover(el, { container: el.parentElement, animation: false });
    });
  };

  let searchTimeout;
  let lastExtraFilter;
  let filterData = () => {
    if (extraFilter.resposiblePartyName != undefined && extraFilter.clientName != undefined) {
      responsiblePartyArr = [
        { id: 1, text: extraFilter.resposiblePartyName },
        // { id: 2, text: extraFilter.clientName }
        { id: 2, text: 'Client' },
      ];
    }

    if (searchTimeout != undefined) {
      clearTimeout(searchTimeout);
    }
    searchTimeout = setTimeout(() => {
      if (datatableRef != undefined) {
        if (firstTimeGridLoad == true) {
          firstTimeGridLoad = false;
          return;
        }
        if (
          lastExtraFilter != undefined &&
          (lastExtraFilter.unitId != extraFilter.unitId ||
            lastExtraFilter.clientId != extraFilter.clientId ||
            lastExtraFilter.taskSubType != extraFilter.taskSubType)
        ) {
          tasks = [];
          taskTemplates = [];
        }
        if (extraFilter.taskType == 1) {
          if (
            extraFilter.taskSubType == 1 &&
            extraFilter.clientTypes.length == 0 &&
            extraFilter.registrationTypes.length == 0
          ) {
            return showDialog({
              message:
                'Sorry, You need to select at least one client type or registration type to view results in this module.',
            });
          }
          if (extraFilter.taskSubType == 2 && extraFilter.projectTypes.length == 0) {
            return showDialog({
              message:
                "This client doesn't have any project added in its profile. Please add projects first to the client's profile",
            });
          }
          if (
            extraFilter.taskSubType == 3 &&
            extraFilter.clientTypes.length == 0 &&
            extraFilter.registrationTypes.length == 0 &&
            extraFilter.projectTypes.length == 0
          ) {
            return showDialog({
              message:
                'Sorry, You need to select at least one client type or registration type or project to view results in this module.',
            });
          }
        }
        selectedTasks = [];
        datatableRef.initializeState();
        lastExtraFilter = cloneArray(extraFilter);
      }
    }, 500);
  };

  let bulkAction = [
    { id: 1, text: 'Change Frequency', openModalId: 'changeFrequency' },
    { id: 2, text: 'Change Assignee', openModalId: 'changeAssignee' },
    { id: 3, text: 'Set Open Date', openModalId: 'setOpenDate' },
    { id: 4, text: 'Set Due Date', openModalId: 'setDueDate' },
    {
      id: 5,
      text: 'Change Responsible Party',
      openModalId: 'changeResponsibleParty',
    },
    { id: 6, text: 'Add', openModalId: 'add' },
  ];

  let funds = [
    { id: 1, text: 'Funds 1' },
    { id: 2, text: 'Funds 2' },
    { id: 3, text: 'Funds 3' },
  ];
  let taskActivityTypes = [];
  let taskServiceType = [];
  let frequency = [
    { id: -1, text: 'As occurs' },
    { id: 1, text: 'Daily' },
    { id: 2, text: 'Weekly' },
    { id: 3, text: 'Monthly' },
    { id: 4, text: 'Quarterly' },
    { id: 5, text: 'Annually' },
    { id: 6, text: 'Custom' },
  ];
  let assignee = [
    { id: 1, text: 'Stacy' },
    { id: 2, text: 'Joe' },
    { id: 3, text: 'George' },
  ];

  let responsiblePartyArr = [
    { id: 1, text: 'Us' },
    { id: 2, text: 'Client' },
  ];

  import { onMount, getContext, setContext, onDestroy } from 'svelte';

  // Service type list in the Assign Task
  const assignServiceType = async () => {
    if (extraFilter?.unitId) {
      const result = await client.sowServiceType({ units: [{ id: extraFilter.unitId }] });
      taskServiceType = result?.data?.payload || [];
    }
  };

  onMount(() => {
    let params = {
      units: [{ id: extraFilter.unitId }],
    };
    assignServiceType();
    client.getactivityTypes(params).then((response) => {
      taskActivityTypes = [{ id: -1, name: 'No Type' }, ...response.data.taskActivityTypes];
    });
  });
  const showDialog = getContext('showDialog');
  let taskTemplates = [];
  let tasks = [];
  // let tasks=[{
  //       "id": "",
  //       "unitId": 5,
  //       "name": "Task",
  //       "purpose": "Task",
  //       "status": "",
  //       "description": "Task",
  //       "taskType": 1,
  //       "responsibleParty": 1,
  //       "requireReview": 0,
  //       "unitProjectId": "",
  //       "recurring": 0,
  //       "recurringType": "",
  //       "recurringCustom": 0,
  //       "recurringEvery": 0,
  //       "assigneeUserId": 54,
  //       "collabratorReviewStatus": "",
  //       "collabratorUserId": "",
  //       "collabratorSubmitNotes": "",
  //       "collabratorReviewNotes": "",
  //       "openDate": "2021-02-23",
  //       "dueDate": "2021-02-23",
  //       "taskTemplateId": "",
  //       "clients": [
  //           {
  //               "id": 141,
  //               "clientFundProfiles": []
  //           }
  //       ],
  //       "users": [],
  //       "urls": [],
  //       "attachments": [],
  //       "subTasks": [],
  //       "comeFrom": "assignTask"
  //   }]
  setContext('taskAction', (params) => {
    if (addTaskModal != undefined) {
      addTaskModal.hide();
    }
    if (taskTempleteModal != undefined) {
      taskTempleteModal.hide();
    }
    if (params.type == 'saveTask') {
      let oldTasks = tasks;
      if (editTaskKey != undefined) {
        oldTasks[editTaskKey] = params.values;
      } else {
        oldTasks.push(params.values);
      }
      tasks = oldTasks;
    } else if (params.type == 'saveTaskTemplate') {
      datatableRef.changeData({ id: params.id, subTaskTemplates: params.subTaskTemplates }, 'id');
    }
  });

  import DataTable from '../DataTable/DataTable.svelte';

  let datatableRef;
  let scrollRef;
  let checkBoxSelected = false;
  let selectedTasks = [];
  const handleCheckbox = (e) => {
    checkBoxSelected = e.target.checked;
    if (checkBoxSelected) {
      selectedTasks = datatableRef.getValues().map((item) => {
        return { id: item.id };
      });
    } else {
      selectedTasks = [];
    }
  };

  let allColumns = [
    {
      key: 'id',
      label: 'Id',
      sortable: true,
      handleCheckbox: handleCheckbox,
      width: 15,
    },
    { key: 'name', label: 'Task', sortable: true, width: 300 },
    { key: 'purpose', label: 'Purpose', sortable: true },
    { key: 'description', label: 'Short description', sortable: true },
    { key: 'clientNotes', label: 'Notes', sortable: false, width: 40 },
    {
      key: 'responsibleParty',
      label: 'Responsible Party',
      sortable: false,
      width: 120,
    },
    {
      key: 'recurringType',
      label: 'Frequency',
      sortable: true,
      width: 120,
    },
    {
      key: 'clientFundProfileName',
      label: 'Funds',
      sortable: false,
      width: 85,
    },
    {
      key: 'assigneeUserId',
      label: 'Assignee',
      sortable: false,
      width: 85,
    },
    { key: 'openDate', label: 'Open Date', sortable: true, width: 140 },
    { key: 'dueDate', label: 'Due Date', sortable: true, width: 140 },
    // { key: "clone", label: "Select", sortable: false,width:20 }
  ];

  var totalColumnWidth = 200;
  allColumns.map((item) => {
    if (item.width) {
      totalColumnWidth += item.width;
    }
    return item;
  });
  let maxWidth = (window.screen.width - totalColumnWidth) / 2;

  let columns = [...allColumns];

  let getData = (queries) => {
    if (extraFilter.taskType == 2) {
      columns = allColumns.filter((item) => item.key !== 'responsibleParty');
    } else {
      columns = allColumns;
    }
    let extraFilterRequest = { ...extraFilter };
    delete extraFilterRequest.clientFundProfile;
    delete extraFilterRequest.unitUsers;
    return client.taskAssignList(500, 1, {
      ...queries,
      ...extraFilterRequest,
    });
  };

  let addTaskModal;
  const addTask = () => {
    editTaskKey = undefined;
    addTaskModal.show(extraFilter);
  };
  let editTaskKey;
  const editTask = (key) => {
    editTaskKey = key;
    let form = tasks[key];
    form.editTask = true;
    addTaskModal.show(form);
    var modal = Modal.getInstance(document.getElementById('assignTaskModal'));
    modal.hide();
  };
  const assignTaskModal = () => {
    var modal = new Modal(document.getElementById('assignTaskModal'), {
      keyboard: false,
    });
    modal.show();
    setTimeout(() => {
      initPopupOver();
    }, 1000);
  };

  const assignTask = () => {
    if (taskTemplates.length == 0 && tasks.length == 0) {
      return showDialog({ message: 'No Task Selected' });
    }
    client
      .taskAssignSave({
        unitId: extraFilter.unitId,
        clientId: extraFilter.clientId,
        taskType: extraFilter.taskType,
        unitProjectId: extraFilter.unitProjectId,
        taskTemplates,
        tasks,
      })
      .then(async (result) => {
        checkBoxSelected = false;
        selectedTasks = [];
        tasks = [];
        taskTemplates = [];
        filterData();
        showDialog({
          message: 'Tasks have been assigned successfully.',
          type: 'success',
        });
      })
      .catch((err) => {
        showDialog({ message: [err.message] });
      });
  };
  const getFundTitle = (id) => {
    if (id != undefined && extraFilter.clientFundProfile.length > 0) {
      let key = searchKeyByValue(extraFilter.clientFundProfile, 'id', id);
      if (key != -1) {
        return extraFilter.clientFundProfile[key].name;
      }
    }
    return '';
  };
  const getAssigneeTitle = (id) => {
    let key = searchKeyByValue(extraFilter.unitUsers, 'userId', id);
    if (key != -1) {
      return extraFilter.unitUsers[key].fullName;
    } else {
      return 'Assignee';
    }
  };

  const getResponsiblePartyTitle = (val) => {
    if (val > 0) {
      let key = searchKeyByValue(responsiblePartyArr, 'id', val);
      return key != -1 ? responsiblePartyArr[key].text : '';
    } else {
      return '';
    }
  };
  const getRecurringTitle = (row) => {
    if (row.recurring == 1) {
      if (row.recurringCustom == 1) {
        return frequency[6].text;
      }
      let key = searchKeyByValue(frequency, 'id', row.recurringType);
      if (key != -1) {
        return frequency[key].text;
      }
    }
    return '';
  };

  import ChangeAssignee from './ChangeAssignee.svelte';
  import SetOpenDate from './SetOpenDate.svelte';
  import SetDueDate from './SetDueDate.svelte';
  import SetClientNotes from './SetClientNotes.svelte';
  import ChangeFrequency from './ChangeFrequency.svelte';
  import ReccuringCustom from 'components/ReccuringCustom.svelte';
  import ActiveEngagementType from 'components/AddClient/ActiveEngagementType.svelte';
  import Client from 'root/routes/Client.svelte';
  import AssignTaskSubFilter from './AssignTaskSubFilter.svelte';
  import TaskChangeResponsiblePartyModal from './TaskChangeResponsiblePartyModal.svelte';

  const onBulkAction = (item) => {
    if (item.comeFrom == 'openDate') {
      for (var i in selectedTasks) {
        datatableRef.changeData({ id: selectedTasks[i].id, openDate: item.date }, 'id');
      }
    }
    if (item.comeFrom == 'changeAssignee') {
      for (var i in selectedTasks) {
        datatableRef.changeData(
          {
            id: selectedTasks[i].id,
            assigneeUserId: item.assigneeUserId,
          },
          'id',
        );
      }
    }
    if (item.comeFrom == 'changeRecurring') {
      for (var i in selectedTasks) {
        datatableRef.changeData(
          {
            id: selectedTasks[i].id,
            recurringCustom: item.recurringCustom,
            recurringType: item.recurringType,
            recurringEvery: item.recurringEvery,
            recurringTypeLabel: getRecurringTitle({
              id: selectedTasks[i].id,
              recurring: 1,
              recurringCustom: item.recurringCustom,
              recurringType: item.recurringType,
              recurringEvery: item.recurringEvery,
            }),
          },
          'id',
        );
      }
    }
    if (item.comeFrom == 'updateRecurring') {
      datatableRef.changeData(
        {
          id: recurringRow.id,
          recurringCustom: item.recurringCustom,
          recurringType: item.recurringType,
          recurringEvery: item.recurringEvery,
          recurringTypeLabel: getRecurringTitle({
            id: recurringRow.id,
            recurring: 1,
            recurringCustom: item.recurringCustom,
            recurringType: item.recurringType,
            recurringEvery: item.recurringEvery,
          }),
        },
        'id',
      );
      recurringRow = undefined;
    }
    if (item.comeFrom == 'clientNotes') {
      datatableRef.changeData(
        {
          id: item.id,
          clientNotes: item.clientNotes,
        },
        'id',
      );
    }
    if (item.comeFrom == 'dueDate') {
      for (var i in selectedTasks) {
        datatableRef.changeData({ id: selectedTasks[i].id, dueDate: item.date }, 'id');
      }
    }
  };

  const showClientNotes = (row) => {
    modalClientNotes.show(row);
  };
  const changeRecurring = (row) => {
    openModal('changeFrequency', row);
    recurringRow = row;
  };
  const openModal = (openModalId, row) => {
    if (openModalId == 'changeFrequency') {
      changeFrequency.setRecurringRow(row);
    }
    let modal = new Modal(document.getElementById(openModalId), {
      keyboard: false,
    });
    modal.show();
  };
  const updateRowAdded = (row) => {
    datatableRef.changeData(
      {
        id: row.id,
        added: searchKeyByValue(taskTemplates, 'id', row.id) != -1,
      },
      'id',
    );
    setTimeout(() => {
      initPopupOver();
    }, 300);
  };

  const getTaskTemplateCount = (row) => {
    let arr = taskTemplates.filter((item) => {
      return item.id == row.id;
    });
    let count = arr.length;
    return count;
  };
  const selectTemplate = (row) => {
    let fundError = row.associatedFund == 1 && row.clientFundProfileId == undefined;
    if (
      fundError ||
      row.dueDate == '' ||
      row.openDate == '' ||
      (extraFilter.taskType == 1 && !(row.responsibleParty > 0)) ||
      row.assigneeUserId == undefined ||
      new Date(row.openDate) > new Date(row.dueDate)
    ) {
      let message = '';
      let addErrors = [];
      if (fundError) {
        addErrors.push('funds');
      }
      if (extraFilter.taskType == 1 && !(row.responsibleParty > 0)) {
        addErrors.push('responsible party');
      }
      if (row.assigneeUserId == undefined) {
        addErrors.push('assignee');
      }
      if (row.openDate == '') {
        addErrors.push('open date');
      }
      if (row.dueDate == '') {
        addErrors.push('due date');
      }
      if (addErrors.length > 0) {
        let errorMessage = '';
        if (addErrors.length > 1) {
          let last_error = addErrors[addErrors.length - 1];
          addErrors.splice(-1, 1);
          errorMessage = addErrors.join(', ') + ' and ' + last_error;
        } else {
          errorMessage = addErrors[0];
        }
        message = 'Please select ' + errorMessage + ' to add';
      }
      if (
        row.openDate != '' &&
        row.openDate != '' &&
        new Date(row.openDate) > new Date(row.dueDate)
      ) {
        message += (message != '' ? ', ' : '') + 'Please select due date greater than open date';
      }
      showDialog({ message });
      return;
    }

    var elements = document.querySelectorAll('.popover.show');
    elements.forEach(function (el) {
      el.remove();
    });

    let oldTaskTemplates = taskTemplates;
    oldTaskTemplates.push(cloneArray(row));
    taskTemplates = oldTaskTemplates;
    setTimeout(() => {
      updateRowAdded(row);
    }, 250);

    return;
    showDialog({
      type: 'confirm',
      title: '',
      message: 'Are you sure ?',
      okFunc: () => {
        client.taskTemplateClone({ id: row.id }).then(async (result) => {
          selectedTasks = [];
          filterData();
        });
      },
    });
  };
  let modalClientNotes;
</script>

<div class="d-flex flex-column h-100 assign-task-table">
  <div class="filter-content top-menu-filter assign-task-block">
    <div class="d-flex flex-row">
      <div class="w-100">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div class="d-flex flex-row align-items-center">
            <div class="bulk-action-filter me-1">
              <DropDown
                checkbox={false}
                active={true}
                title="Action"
                titleClass="text-primary"
                option={bulkAction}
                on:onSelect={(item) => {
                  if (selectedTasks.length == 0) {
                    return showDialog({
                      message: 'No Task Selected',
                    });
                  }
                  if (item.detail.openModalId == 'changeFrequency') {
                    let allTasks = datatableRef.getValues();
                    if (
                      selectedTasks.length !=
                      selectedTasks.filter((item) => {
                        return allTasks[searchKeyByValue(allTasks, 'id', item.id)].recurring == 1;
                      }).length
                    ) {
                      return showDialog({
                        message: 'Please select only recurring task',
                      });
                    }
                  }
                  if (item.detail.openModalId == 'add') {
                    let allTasks = datatableRef.getValues();
                    let allMessage = '';
                    for (var i in selectedTasks) {
                      let row = allTasks[searchKeyByValue(allTasks, 'id', selectedTasks[i].id)];
                      let fundError =
                        row.associatedFund == 1 && row.clientFundProfileId == undefined;
                      if (
                        fundError ||
                        row.dueDate == '' ||
                        row.openDate == '' ||
                        (extraFilter.taskType == 1 && !(row.responsibleParty > 0)) ||
                        row.assigneeUserId == undefined ||
                        new Date(row.openDate) > new Date(row.dueDate)
                      ) {
                        let message = '';
                        let addErrors = [];
                        if (fundError) {
                          addErrors.push('funds');
                        }
                        if (extraFilter.taskType == 1 && !(row.responsibleParty > 0)) {
                          addErrors.push('responsible party');
                        }
                        if (row.assigneeUserId == undefined) {
                          addErrors.push('assignee');
                        }
                        if (row.openDate == '') {
                          addErrors.push('open date');
                        }
                        if (row.dueDate == '') {
                          addErrors.push('due date');
                        }
                        if (addErrors.length > 0) {
                          let errorMessage = '';
                          if (addErrors.length > 1) {
                            let last_error = addErrors[addErrors.length - 1];
                            addErrors.splice(-1, 1);
                            errorMessage = addErrors.join(', ') + ' and ' + last_error;
                          } else {
                            errorMessage = addErrors[0];
                          }
                          message = 'Please select ' + errorMessage + ' to add';
                        }
                        if (
                          row.openDate != '' &&
                          row.openDate != '' &&
                          new Date(row.openDate) > new Date(row.dueDate)
                        ) {
                          message +=
                            (message != '' ? ', ' : '') +
                            'Please select due date greater than open date';
                        }
                        if (message != '') {
                          allMessage +=
                            'Task ' +
                            (Number(i) + 1) +
                            ' (' +
                            row.name +
                            ') has following error <br/>' +
                            message +
                            '<br/><br/>';
                        }
                      }
                    }
                    if (allMessage != '') {
                      showDialog({
                        message: allMessage,
                        isHtmlMessage: true,
                      });
                      return;
                    }
                    for (var i in selectedTasks) {
                      let row = allTasks[searchKeyByValue(allTasks, 'id', selectedTasks[i].id)];
                      let oldTaskTemplates = taskTemplates;
                      oldTaskTemplates.push(cloneArray(row));
                      taskTemplates = oldTaskTemplates;
                      setTimeout(() => {
                        updateRowAdded(row);
                      }, 250);
                    }
                  } else if (item.detail.openModalId == 'changeResponsibleParty') {
                    changeResponsibleParty.showModal();
                  } else {
                    openModal(item.detail.openModalId);
                  }
                }}
                Style="select-block font-size-13 w-100"
              />
            </div>

            <div class="search-client-input position-relative">
              {#if extraFilter.searchKeyword && extraFilter.searchKeyword != ''}
                <img
                  class="position-absolute cursor"
                  alt=""
                  src="/images/cross.svg"
                  width="18"
                  on:click={(e) => {
                    extraFilter.searchKeyword = '';
                  }}
                />
              {:else}
                <img
                  class="position-absolute"
                  alt=""
                  src="/images/search.svg"
                />
              {/if}
              <input
                class="form-control"
                bind:value={extraFilter.searchKeyword}
                placeholder="Search Task"
                type="text"
              />
            </div>
            <!-- <div class="checkbox c-checkbox px-2">
				<label class="font-size-12 d-flex align-items-center"><input type="checkbox" bind:checked={extraFilter.recurringCheck} on:change={(event)=>extraFilter.recurring=event.target.checked?1:0}    />
					<span class="check-img"></span>
					Recurring Task
				</label>
			 </div>  -->
            <DropDown
              title="Frequency"
              deleteSelected={true}
              checkbox={true}
              active={true}
              titleChanged={true}
              checkedFields="checked"
              option={frequency}
              removeIcon={true}
              on:onClear={(event) => {
                extraFilter.recurringTypes = [];
              }}
              Style="select-block font-size-13 select-frequency"
              on:onSelect={(event) => {
                extraFilter.recurringTypes = event.detail;
              }}
            />

            <!-- Service type filter -->
            {#if taskServiceType.length > 0}
              <DropDown
                searchbox={true}
                checkbox={true}
                deleteSelected={true}
                titleChanged={false}
                title="Service Type"
                checkedFields="checked"
                removeIcon={true}
                option={taskServiceType}
                Style="select-block"
                on:onClear={() => {
                  extraFilter.taskServiceType = [];
                }}
                on:onSelect={(item) => {
                  extraFilter.taskServiceType = item.detail;
                }}
              />
            {/if}

            <DropDown
              searchbox={true}
              checkbox={true}
              checkedFields="checked"
              title="Activity Type"
              option={taskActivityTypes}
              Style="select-block"
              titleChanged={true}
              removeIcon={true}
              on:onClear={(event) => {
                extraFilter.taskActivityTypes = [];
              }}
              on:onSelect={(event) => {
                extraFilter.taskActivityTypes = event.detail;
              }}
            />

            <button
              type="button"
              class="p-0 reset-filter color-blue d-flex flex-row align-items-center text-start ms-1 bg-transparent border-0"
              on:click={() => {
                frequency = frequency.map((item) => {
                  item.checked = false;
                  return item;
                });
                taskActivityTypes = taskActivityTypes.map((item) => {
                  item.checked = false;
                  return item;
                });
                taskServiceType = taskServiceType.map((item) => {
                  item.checked = false;
                  return item;
                });
                extraFilter = {
                  ...extraFilter,
                  recurringCheck: false,
                  recurring: 0,
                  searchKeyword: '',
                  recurringTypes: [],
                  taskActivityTypes: [],
                  taskServiceType: [],
                };
              }}
            >
              <img
                class="icon-14 me-2"
                alt=""
                src="/images/reset.svg"
              />
              Reset Filter
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-end btn-add-tasks justify-content-end">
        {#if extraFilter.taskType == 1 && extraFilter.clientId > 0 && extraFilter.taskSubType > 0}
          <AssignTaskSubFilter
            comeFrom="assignTask"
            extraFilter={extraFilter}
            clientTypes={clientTypes}
            registrationTypes={registrationTypes}
            projectTypes={projectTypes}
            applyFilter={(params) => {
              extraFilter = params;
            }}
          />
        {/if}

        {#if taskTemplates.length + tasks.length > 0}
          <button
            type="button"
            style="padding: 5px;background:#7030A0 !important;border-color:#7030A0 !important;"
            class=" me-1 mb-0 px-3 font-size-13 add-task-btn"
            on:click={() => {
              //  <button type="button" class="font-size-13 px-3 me-1 add-task-btn" on:click={()=>{
              assignTaskModal();
            }}
          >
            {taskTemplates.length + tasks.length} added task(s)
          </button>
        {/if}
        <button
          type="button"
          on:click={addTask}
          style="padding: 5px;"
          class="mb-0 px-3 font-size-13 add-task-btn">Create Task</button
        >
      </div>
    </div>
  </div>

  <div
    class="tab-pane page-content fade show page-content active m-3"
    id="home2"
    role="tabpanel"
    aria-labelledby="home-tab2"
    bind:this={scrollRef}
  >
    <DataTable
      datatableCallback={(state) => {
        setTimeout(() => {
          initPopupOver();
        }, 500);
      }}
      bind:this={datatableRef}
      columns={columns}
      scrollRef={scrollRef}
      getData={getData}
      let:row
    >
      <td class="text-muted">
        <div class="checkbox c-checkbox">
          <label>
            <input
              type="checkbox"
              name="live_bidding"
              checked={checkBoxSelected}
              on:change={(event) => {
                let oldSelectedTasks = selectedTasks;
                if (event.target.checked) {
                  oldSelectedTasks.push({ id: row.id });
                } else {
                  oldSelectedTasks.splice(searchKeyByValue(selectedTasks, 'id', row.id), 1);
                }
                selectedTasks = oldSelectedTasks;
              }}
              value="1"
            />
            <span class="check-img"></span>
          </label>
        </div>
      </td>
      <td class="text-muted">
        {row.name}
        {#if row.subTaskTemplateCount > 0}
          <button
            type="button"
            class="bg-transparent border-0 p-0 color-blue text-break"
            on:click={() => {
              editTaskTemplate(row.id);
            }}
          >
            <img
              alt=""
              class="icon-14 ms-2 me-1"
              src="/images/checklist.svg"
            />
            <span class="align-middle">{row.subTaskTemplateCount}</span>
          </button>
        {/if}
      </td>
      <td class="text-muted">
        <button
          type="button"
          class="bg-transparent border-0 color-blue text-start text-break px-0 add_task_popup"
          data-bs-placement="top"
          data-bs-toggle="popover"
          data-bs-trigger="hover focus"
          data-bs-content={row.purpose}
        >
          <span
            class="column-unit-name"
            style="max-width:{maxWidth}px">{row.purpose}</span
          >
        </button>
      </td>
      <td class="text-muted">
        <button
          type="button"
          class="bg-transparent border-0 color-blue text-start text-break px-0 add_task_popup"
          data-bs-placement="top"
          data-bs-toggle="popover"
          data-bs-trigger="hover focus"
          data-bs-content={row.description}
        >
          <span
            class="column-unit-name"
            style="max-width:{maxWidth}px">{row.description}</span
          >
        </button>
      </td>
      <td class="text-muted">
        <button
          on:click={() => {
            showClientNotes(row);
          }}
          type="button"
          class="bg-transparent border-0 color-blue d-flex flex-row align-items-center p-0 me-4"
        >
          {row.clientNotes != undefined && row.clientNotes != '' ? 'Edit' : 'Add'}
        </button>
      </td>

      {#if extraFilter.taskType == 1}
        <td class="text-muted">
          <div class="d-flex justify-content-start align-items-center">
            <DropDown
              deleteSelected={false}
              checkbox={false}
              active={true}
              titleChanged={true}
              title={getResponsiblePartyTitle(row.responsibleParty)}
              option={responsiblePartyArr}
              Style="select-block font-size-13 select-box-dropdown"
              on:onSelect={(event) => {
                row.responsibleParty = event.detail.id;
              }}
            />
          </div>
        </td>
      {/if}

      <td class="text-muted">
        <div class="d-flex justify-content-start align-items-center">
          {#if row.recurring == 1}
            <DropDown
              deleteSelected={false}
              checkbox={false}
              active={true}
              titleChanged={true}
              title={getRecurringTitle(row)}
              option={frequency}
              Style="select-block font-size-13 select-box-dropdown"
              on:onSelect={(event) => {
                if (event.detail.id == 6) {
                  row.frequencyType = 6;
                  row.recurringCustom = 1;
                  row.recurringType = 1;
                  row.recurringEvery = 1;
                  changeRecurring(row);
                } else {
                  row.recurringCustom = 0;
                  row.recurringType = event.detail.id;
                }
                row.recurringTypeLabel = getRecurringTitle(row);
              }}
            />
            <button
              on:click={() => {
                changeRecurring(row);
              }}
              type="button"
              class="bg-transparent border-0 color-blue d-flex flex-row align-items-center p-0 me-4"
            >
              Edit</button
            >
            <!-- {#if row.reccuringCustom==1}
					{/if} -->
          {/if}
        </div>
      </td>
      <td class="text-muted">
        {#if row.associatedFund == 1}
          <DropDown
            deleteSelected={false}
            titleChanged={true}
            checkbox={false}
            active={true}
            title="Funds"
            option={extraFilter.clientFundProfile}
            Style="select-block font-size-13  d-block select-box-dropdown"
            on:onSelect={(event) => {
              row.clientFundProfileId = event.detail.id;
            }}
          />
        {/if}
      </td>
      <td class="text-muted">
        <DropDown
          deleteSelected={false}
          searchbox={true}
          checkbox={false}
          active={true}
          titleChanged={true}
          title={getAssigneeTitle(row.assigneeUserId)}
          labelFields="fullName"
          on:onSelect={(event) => {
            row.assigneeUserId = event.detail.userId;
          }}
          option={extraFilter.unitUsers}
          Style="select-block font-size-13  d-inline-block select-box-dropdown"
        />
      </td>
      <td class="text-muted">
        <DatePicker
          style="active select-border"
          placeholder="Open Date"
          on:change={(value) => {
            row.openDate = value.detail[1];
          }}
          value={row.openDate}
        />
      </td>
      <td class="text-muted">
        <DatePicker
          style="active select-border"
          placeholder="Due Date"
          on:change={(value) => {
            row.dueDate = value.detail[1];
          }}
          value={row.dueDate}
        />
      </td>
      <!-- <td class="text-muted text-nowrap text-center">
				  <button type="button" class="bg-transparent border-0 color-blue  {getTaskTemplateCount(row) >0?'add_task_popup':''}" on:click={()=>{
					selectTemplate(row)
				  }}
					data-bs-placement="left" data-bs-toggle="popover" data-bs-trigger="hover"  data-bs-content="Click to add this task again."
				  >
				  {#if getTaskTemplateCount(row) >0}
				  {#if getTaskTemplateCount(row)==1}
					   <span class="added-assignee">Added + </span>
					{:else}
						 <span class="added-assignee">Added <span class="task-count">{getTaskTemplateCount(row)}</span></span>
				  {/if}

				  {:else}
					  Add
				  {/if}
				  </button>
				</td> -->
    </DataTable>
  </div>
</div>

<AddTaskModal
  bind:this={addTaskModal}
  comeFrom="assignTask"
/>

<!-- Button trigger modal -->

<!-- Modal -->
<div
  class="modal fade assign-task-modal p-3"
  id="assignTaskModal"
  tabindex="-1"
  aria-labelledby="assignTaskModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl h-100 my-0">
    <div class="modal-content h-100 d-flex flex-column">
      <div class="modal-header">
        <h5
          class="modal-title"
          id="assignTaskModalLabel"
        >
          Assign Tasks
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body page-content">
        <div class="d-flex flex-column h-100">
          <div class="page-content table-content mt-1 px-0">
            {#if taskTemplates.length == 0 && tasks.length == 0}
              <h5
                class="modal-title"
                id="assignTaskModalLabel"
              >
                No Task Selected
              </h5>
            {/if}
            {#if taskTemplates.length > 0}
              <h5 class="modal-title font-size-14 mb-2">Selected Task Templates</h5>
              <table class="table table-vcenter card-table">
                <thead class="table-fixed-head">
                  <tr>
                    <th width="180">Task</th>
                    <th>Purpose</th>
                    <th>Short description</th>
                    <th>Notes</th>
                    {#if extraFilter.taskType == 1}
                      <th width="85">Responsible Party</th>
                    {/if}
                    <th width="85">Frequency</th>
                    <th width="140">Funds</th>
                    <th width="140">Assignee</th>
                    <th width="80">Open Date</th>
                    <th width="80">Due Date</th>
                    <th width="40">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {#each taskTemplates as row, key}
                    <tr>
                      <td class="text-muted text-break">{row.name}</td>
                      <td class="text-muted text-break">{row.purpose}</td>
                      <td class="text-muted text-break">{row.description}</td>
                      <td class="text-muted text-break">
                        {#if row.clientNotes != undefined && row.clientNotes.trim() != ''}
                          <span
                            data-bs-content={row.clientNotes}
                            data-bs-placement="top"
                            data-bs-toggle="popover"
                            data-bs-trigger="hover focus"
                            class="icon-16 color-blue add_task_popup cursor"
                            alt="">View</span
                          >
                        {/if}
                      </td>
                      {#if extraFilter.taskType == 1}
                        <td class="text-muted">{getResponsiblePartyTitle(row.responsibleParty)}</td>
                      {/if}
                      <td class="text-muted">
                        {row.recurringTypeLabel}
                      </td>
                      <td class="text-muted">
                        <span class="user-name d-block"
                          >{row.clientFundProfileId != undefined
                            ? getFundTitle(row.clientFundProfileId)
                            : ''}</span
                        >
                      </td>
                      <td class="text-muted">
                        <span class="user-name d-block">{getAssigneeTitle(row.assigneeUserId)}</span
                        >
                      </td>
                      <td class="text-muted">
                        {userDateFormat(row.openDate)}
                      </td>
                      <td class="text-muted">
                        {userDateFormat(row.dueDate)}
                      </td>
                      <td class="text-end">
                        <button
                          on:click={() => {
                            let old = taskTemplates;
                            old.splice(key, 1);
                            taskTemplates = old;
                            updateRowAdded(row);
                          }}
                          class="btn btn-link border-0 outline-none bg-transparent shadow-none p-0"
                        >
                          <img
                            class="icon-16"
                            alt=""
                            src="/images/remove.svg"
                          />
                        </button>
                      </td>
                    </tr>
                  {/each}
                </tbody>
              </table>
            {/if}
            {#if tasks.length > 0}
              <h5 class="modal-title font-size-14 mb-2">Selected Tasks</h5>
              <table class="table table-vcenter card-table">
                <thead class="table-fixed-head">
                  <tr>
                    <th width="180">Task</th>
                    <th>Purpose</th>
                    <th>Short description</th>
                    <th>Notes</th>
                    {#if extraFilter.taskType == 1}
                      <th width="85">Responsible Party</th>
                    {/if}
                    <th width="85">Frequency</th>
                    <th width="150">Funds</th>
                    <th width="150">Assignee</th>
                    <th width="90">Open Date</th>
                    <th width="90">Due Date</th>
                    <th width="40">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {#each tasks as row, key}
                    <tr>
                      <td class="text-muted text-break">
                        <button
                          on:click={() => {
                            editTask(key);
                          }}
                          class="btn btn-link text-start border-0 outline-none bg-transparent shadow-none btn-sm p-0 m-0"
                        >
                          {row.name}
                        </button>
                      </td>
                      <td class="text-muted text-break">{row.purpose}</td>
                      <td class="text-muted text-break">{row.description}</td>
                      <td class="text-muted text-break">
                        {#if row.clientNotes != undefined && row.clientNotes.trim() != ''}
                          <span
                            data-bs-content={row.clientNotes}
                            data-bs-placement="top"
                            data-bs-toggle="popover"
                            data-bs-trigger="hover focus"
                            class="icon-16 color-blue add_task_popup cursor"
                            alt="">View</span
                          >
                        {/if}
                      </td>
                      {#if extraFilter.taskType == 1}
                        <td class="text-muted">{getResponsiblePartyTitle(row.responsibleParty)}</td>
                      {/if}
                      <td class="text-muted">
                        {getRecurringTitle(row)}
                      </td>
                      <td class="text-muted">
                        {row.clients[0] != undefined &&
                        row.clients[0].clientFundProfiles &&
                        row.clients[0].clientFundProfiles.length > 0
                          ? row.clients[0].clientFundProfiles[0].name
                          : ''}
                      </td>
                      <td class="text-muted">
                        {getAssigneeTitle(row.assigneeUserId)}
                      </td>
                      <td class="text-muted">
                        {userDateFormat(row.openDate)}
                      </td>
                      <td class="text-muted">
                        {userDateFormat(row.dueDate)}
                      </td>
                      <td class="text-end">
                        <button
                          on:click={() => {
                            let old = tasks;
                            old.splice(key, 1);
                            tasks = old;
                          }}
                          class="btn btn-link border-0 outline-none bg-transparent shadow-none p-0"
                        >
                          <img
                            class="icon-16"
                            alt=""
                            src="/images/remove.svg"
                          />
                        </button>
                      </td>
                    </tr>
                  {/each}
                </tbody>
              </table>
            {/if}
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          data-bs-dismiss="modal"
          on:click={assignTask}
          class="btn btn-primary font-size-12 shadow-none px-3"
          ><svg
            class="icon-16"
            width="16"
            height="16"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ><path
              d="M99.707 78.125L81.8848 95.9473L77.4902 91.5527L87.793 81.25H56.25V75H87.793L77.4902 64.6973L81.8848 60.3027L99.707 78.125ZM65.9668 68.457C64.6973 65.6576 63.0859 63.1348 61.1328 60.8887C59.1797 58.6426 56.9499 56.7057 54.4434 55.0781C51.9368 53.4505 49.2676 52.1973 46.4355 51.3184C43.6035 50.4395 40.625 50 37.5 50C34.6354 50 31.8685 50.3743 29.1992 51.123C26.5299 51.8717 24.0397 52.9134 21.7285 54.248C19.4173 55.5827 17.3177 57.2103 15.4297 59.1309C13.5417 61.0514 11.9141 63.1673 10.5469 65.4785C9.17969 67.7897 8.12174 70.2799 7.37305 72.9492C6.62435 75.6185 6.25 78.3854 6.25 81.25H0C0 77.4414 0.569661 73.7142 1.70898 70.0684C2.84831 66.4225 4.49219 63.0534 6.64062 59.9609C8.78906 56.8685 11.3444 54.1178 14.3066 51.709C17.2689 49.3001 20.5729 47.4609 24.2188 46.1914C22.3958 45.0195 20.7682 43.6686 19.3359 42.1387C17.9036 40.6087 16.6667 38.9323 15.625 37.1094C14.5833 35.2865 13.8184 33.3659 13.3301 31.3477C12.8418 29.3294 12.5651 27.2135 12.5 25C12.5 21.5495 13.151 18.3105 14.4531 15.2832C15.7552 12.2559 17.5293 9.60286 19.7754 7.32422C22.0215 5.04557 24.6745 3.25521 27.7344 1.95312C30.7943 0.651042 34.0495 0 37.5 0C40.9505 0 44.1895 0.651042 47.2168 1.95312C50.2441 3.25521 52.8971 5.0293 55.1758 7.27539C57.4544 9.52148 59.2448 12.1745 60.5469 15.2344C61.849 18.2943 62.5 21.5495 62.5 25C62.5 29.4596 61.4746 33.4961 59.4238 37.1094C57.373 40.7227 54.4922 43.75 50.7812 46.1914C53.125 47.0703 55.3385 48.1608 57.4219 49.4629C59.5052 50.765 61.4258 52.2624 63.1836 53.9551C64.9414 55.6478 66.5365 57.5033 67.9688 59.5215C69.401 61.5397 70.638 63.6719 71.6797 65.918L65.9668 68.457ZM18.75 25C18.75 27.6042 19.2383 30.0293 20.2148 32.2754C21.1914 34.5215 22.526 36.5072 24.2188 38.2324C25.9115 39.9577 27.8971 41.3086 30.1758 42.2852C32.4544 43.2617 34.8958 43.75 37.5 43.75C40.0716 43.75 42.4967 43.2617 44.7754 42.2852C47.054 41.3086 49.0397 39.974 50.7324 38.2812C52.4251 36.5885 53.776 34.6029 54.7852 32.3242C55.7943 30.0456 56.2826 27.6042 56.25 25C56.25 22.4284 55.7617 20.0033 54.7852 17.7246C53.8086 15.446 52.474 13.4603 50.7812 11.7676C49.0885 10.0749 47.0866 8.72396 44.7754 7.71484C42.4642 6.70573 40.0391 6.21745 37.5 6.25C34.8958 6.25 32.4707 6.73828 30.2246 7.71484C27.9785 8.69141 25.9928 10.026 24.2676 11.7188C22.5423 13.4115 21.1914 15.4134 20.2148 17.7246C19.2383 20.0358 18.75 22.4609 18.75 25Z"
              fill="#fff"
            ></path></svg
          >
          Assign Tasks
        </button>
      </div>
    </div>
  </div>
</div>

<ChangeFrequency
  bind:this={changeFrequency}
  onBulkAction={onBulkAction}
  selectedTasks={selectedTasks}
/>
<ChangeAssignee
  onBulkAction={onBulkAction}
  selectedTasks={selectedTasks}
  extraFilter={extraFilter}
/>
<SetOpenDate
  onBulkAction={onBulkAction}
  selectedTasks={selectedTasks}
/>
<SetDueDate
  onBulkAction={onBulkAction}
  selectedTasks={selectedTasks}
/>
<SetClientNotes
  bind:this={modalClientNotes}
  onBulkAction={onBulkAction}
/>
<AddTaskTempleteModal bind:this={taskTempleteModal} />
<TaskChangeResponsiblePartyModal
  bind:this={changeResponsibleParty}
  selectedTasks={selectedTasks}
  responsiblePartyArr={responsiblePartyArr}
  handleClick={(params) => {
    for (var i in selectedTasks) {
      datatableRef.changeData(
        {
          id: selectedTasks[i].id,
          responsibleParty: params.responsibleParty,
        },
        'id',
      );
    }
  }}
/>

<style lang="scss">
  :global(.select-frequency) {
    position: relative;
    top: -1px;
  }
  .column-unit-name {
    max-height: 53px;
    white-space: normal;
  }
  @media (min-width: 1500px) {
    .modal-xl {
      max-width: 1340px;
    }
  }
  .added-assignee {
    background: $blue-color;
    color: $white-color;
    padding: 1px 8px;
    border-radius: 4px;
    .task-count {
      background: $white-color;
      padding: 4px;
      line-height: 8px;
      color: $blue-color;
      padding: 2px 4px;
      display: inline-block;
      border-radius: 2px;
    }
  }
  .bulk-action-filter {
    min-width: 100px;
  }
  .assign-task-block {
    height: 51px;
  }
  .search-client-input {
    input {
      padding-right: 40px;
    }
  }
  .btn-add-task {
    flex: 0 0 106px;
    max-width: 106px;
  }
</style>
